export enum EAppModule {
  Incoming = "incoming.module",
  Outgoing = "outgoing.module",
  AddressBook = "addressBook.module",
  Desk = "desk.module",
  Cases = "cases.module",
  CasesExt = "casesext.module",
  Drive = "drive.module",
  CaseDrive = "casedrive.module",
  Word = "word.module",
  Notes = "notes.module",
  Email = "email.module",
  Letters = "letters.module",

  EncryptedParcels = "encrypted_parcels.module",
  WordExt = "wordext.module",
  Tasks = "tasks.module",
  Workspace = "workspace.module",

  CourtPortal = "courtportal.module",
  Budget = "budget.module",
  Mailroom = "mailroom.module",
  Council = "council.module",
}
